<template lang="pug">
div
  v-menu(
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :disabled="isReadonly || isDisabled"
    transition="scale-transition"
    offset-y
    origin="top right"
    left
    min-width="auto"
    @input="tab = menu ? tab : null"
  )
    template(#activator="{ on, attrs }")
      v-text-field(
        v-bind="attrs"
        v-model="range"
        filled
        :class="{ 'x-widget-readonly': isReadonly }"
        :dense="!isLarge"
        :label="myTitle"
        :hint="myHint"
        :hide-details="hasNoHints"
        :prepend-inner-icon="myIcon"
        :rules="rules"
        :append-icon="(isReadonly || isDisabled) ? null : 'mdi-calendar'"
        :outlined="isOutlined"
        :readonly="isReadonly"
        :required="isRequired && !isDisabled"
        :disabled="isDisabled"
        :placeholder="myPlaceholder"
        @blur="commit"
        @click:append="on.click"
        @keydown.enter="e => $emit('actionPerformed', e)"
      )

    v-tabs(v-if="menu" v-model="tab" height="70" grow)
      v-tab(@click="resetTimePicker('timePicker1')" style="min-width: 145px;")
        template(v-if="min")
          .pl-4.pt-3.caption(style="position: absolute; left: 0; top: 0;") De
          .mt-4.text-h6 {{ min }}
        template(v-else)
          .pl-4.pt-3.caption(style="position: absolute; left: 0; top: 0;") Do
          .mt-4.text-h6 Início

      v-tab(@click="resetTimePicker('timePicker1')")
        template(v-if="max")
          .pl-4.pt-3.caption(style="position: absolute; left: 0; top: 0;") Até
          .mt-4.text-h6 {{ max }}
        template(v-else)
          .pl-4.pt-3.caption(style="position: absolute; left: 0; top: 0;") Em
          .mt-4.text-h6 Diante

    v-tabs-items(v-if="menu" v-model="tab")
      v-tab-item
        v-time-picker.x-widget-date-range--date-picker(
          ref="timePicker1"
          v-if="menu"
          v-model="min"
          no-title
          scrollable
          format="24hr"
          locale="pt-br"
          use-seconds
          filled
          @click:second="tab = 1"
        )
          v-tooltip(bottom)
            template(#activator="{ on, attrs }")
              v-btn(
                v-bind="attrs"
                v-on="on"
                icon
                color="primary"
                @click="resetTimePicker('timePicker1', 'selectingHour')"
              )
                .text-outline H
            span
              span.font-weight-light Editar a hora

          v-tooltip(bottom)
            template(#activator="{ on, attrs }")
              v-btn(
                v-bind="attrs"
                v-on="on"
                icon
                color="primary"
                @click="resetTimePicker('timePicker1', 'selectingMinute')"
              )
                .text-outline M
            span
              span.font-weight-light Editar os minutos

          v-tooltip(bottom)
            template(#activator="{ on, attrs }")
              v-btn(
                v-bind="attrs"
                v-on="on"
                icon
                color="primary"
                @click="resetTimePicker('timePicker1', 'selectingSecond')"
              )
                .text-outline S
            span
              span.font-weight-light Editar os segundos

          v-spacer

          v-tooltip(bottom)
            template(#activator="{ on, attrs }")
              v-btn(
                v-bind="attrs"
                v-on="on"
                icon
                color="primary"
                @click="tab = 1"
              )
                v-icon mdi-arrow-right
            span
              span.font-weight-light Avançar


      v-tab-item
        v-time-picker.x-widget-date-range--date-picker(
          ref="timePicker2"
          v-if="menu"
          v-model="max"
          no-title
          scrollable
          format="24hr"
          locale="pt-br"
          use-seconds
          filled
          @click:second="menu = null"
        )
          v-tooltip(bottom)
            template(#activator="{ on, attrs }")
              v-btn(
                v-bind="attrs"
                v-on="on"
                icon
                color="primary"
                @click="resetTimePicker('timePicker2', 'selectingHour')"
              )
                .text-outline H
            span
              span.font-weight-light Editar a hora

          v-tooltip(bottom)
            template(#activator="{ on, attrs }")
              v-btn(
                v-bind="attrs"
                v-on="on"
                icon
                color="primary"
                @click="resetTimePicker('timePicker2', 'selectingMinute')"
              )
                .text-outline M
            span
              span.font-weight-light Editar os minutos

          v-tooltip(bottom)
            template(#activator="{ on, attrs }")
              v-btn(
                v-bind="attrs"
                v-on="on"
                icon
                color="primary"
                @click="resetTimePicker('timePicker2', 'selectingSecond')"
              )
                .text-outline S
            span
              span.font-weight-light Editar os segundos

          v-spacer

          v-tooltip(bottom)
            template(#activator="{ on, attrs }")
              v-btn(
                v-bind="attrs"
                v-on="on"
                icon
                color="primary"
                @click="menu = null"
              )
                v-icon mdi-check
            span
              span.font-weight-light Confirmar

</template>

<style scoped>
.x-widget-date-range--date-picker .v-date-picker-title__year {
  display: none;
}
</style>

<script>
import { getTime } from '@/helpers/dates';

export default {
  props: {
    /**
     * Objeto contendo os valores e campos do contexto no qual o widget está
     * inserido para inferência de propriedades aplicadas em interpolação de
     * templates de texto.
     */
    context: Object,

    /**
     * Instância opcional de um campo do Paper.
     * @type {Keep.Paper.Design.Field}
     */
    field: Object,

    /**
     * Um dos tipos de dados suportados pelo Paper.
     * @type {Keep.Paper.Design.TypeNames}
     */
    dataType: String,

    /**
     * Diz se o componente suporta seleção de intervalo.
     * @type {Boolean}
     */
    allowRange: Boolean,

    /**
     * Valor editado no componente.
     * @type {Any}
     */
    value: {
      validator: (v) => true,
    },
  },

  data: () => ({
    tab: null,
    menu: null,
    range: null,
  }),

  computed: {
    // myName: vm => vm.getIt('name'),
    myTitle: (vm) => vm.getIt("title") || vm.myName,
    mySubtitle: (vm) => vm.getIt("subtitle"),
    myDescription: (vm) => vm.getIt("description"),
    myHint: (vm) => vm.getIt("hint") || vm.mySubtitle,
    myPlaceholder: (vm) => vm.getIt("placeholder"),
    myIcon: (vm) => vm.getIt("icon"),
    hasNoHints: (vm) => vm.hasIt("noHints"),
    isLarge: (vm) => vm.hasIt("large"),
    isDisabled: (vm) => vm.hasIt("disabled"),
    isRequired: (vm) => vm.hasIt("required"),
    isReadonly: (vm) => vm.hasIt("readOnly") || vm.hasIt("readonly"),
    isOutlined: (vm) => vm.hasIt("outlined"),

    // Valor real recebido e devolvido pelo widget.
    content: {
      get() {
        return this.value
      },
      set(value) {
        const { min, max } = (value || {})
        if (min && max) value = { min, max }
        else if (min) value = { min }
        else if (max) value = { max }
        else value = null
        this.$emit("input", value)
      },
    },

    min: {
      get() {
        return this.content?.min || '00:00:00'
      },
      set(value) {
        this.content = { min: value, max: this.max }
      }
    },

    max: {
      get() {
        return this.content?.max || '00:00:00'
      },
      set(value) {
        this.content = { min: this.min, max: value }
      }
    },

    rules() {
      const required = this.isRequired && !this.isDisabled
      const rules = {
        required: (v) => !required || !!v || "Campo requerido",
        validRange: (v) => !v || !!this.parseRange(v) || "Intervalo inválido.",
      }
      return [rules.required, rules.validRange]
    },
  },

  methods: {
    resetTimePicker(picker, part) {
      this.$nextTick(() => {
        if (this.$refs[picker]) {
          this.$set(this.$refs[picker], part || 'selectingHour', true)
        }
      })
    },

    getIt(property) {
      return (
        this[property] ||
        this.$props[property] ||
        this.$attrs[property] ||
        this.field?.[property]
      )
    },
    hasIt(property) {
      if (this.$props[property] === "") return true
      if (this.$attrs[property] === "") return true
      const value =
        this[property] ||
        this.$props[property] ||
        this.$attrs[property] ||
        this.field?.[property]
      return !!value
    },

    parseRange(range) {
      if (!range) return null

      range = range.replace(/\s+/g, '').replace(/\.+/g, '.')
      if (!range.includes('.')) range = `${range}.${range}`

      const tokens = range.split('.')
      if (tokens.length < 1 || tokens.length > 2) return null

      let [ min, max ] = tokens

      min = getTime(min)
      max = getTime(max)

      if (!range.startsWith('.') && !min) return null
      if (!range.endsWith('.') && !max) return null

      if (min && max) return { min, max }
      if (min) return { min }
      if (max) return { max }
      return null
    },

    commit() {
      const range = this.range
      this.content = this.parseRange(range)
      this.$nextTick(() => this.range ||= range)
    },

    restore() {
      let { min, max } = (this.content || {})
      min = getTime(min)
      max = getTime(max)
      let range
      if (min === max) range = min
      else if (min && max) range = `${min} ... ${max}`
      else if (min) range = `${min} ...`
      else if (max) range = `... ${max}`
      this.range = range
    },
  },

  mounted() {
    this.restore()
  },

  watch: {
    value: "restore",
  },
}
</script>
